import React from 'react';
const VendorsIconAlt = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
      fill="none"
    />
    <path
      d="M9 25H13C13.5523 25 14 24.5523 14 24V11.9142C14 11.649 13.8946 11.3946 13.7071 11.2071L9.79289 7.29289C9.60536 7.10536 9.351 7 9.08579 7H9C8.44772 7 8 7.44772 8 8V24C8 24.5523 8.44772 25 9 25Z"
      fill="white"
    />
    <circle cx="22" cy="16" r="2" stroke="#616893" strokeWidth="2" />
    <path
      d="M19 25V23C19 21.8954 19.8954 21 21 21H23C24.1046 21 25 21.8954 25 23V25"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16 25H9C8.44772 25 8 24.5523 8 24L8 8C8 7.44772 8.44772 7 9 7H15.0858C15.351 7 15.6054 7.10536 15.7929 7.29289L20 11.5"
      stroke="#A0A4C0"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M12 21L14 21" stroke="#616893" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 17L16 17" stroke="#616893" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 13L14 13" stroke="#616893" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default VendorsIconAlt;
